<template>
    <div class="play-btn relative w-full h-full">
        <button class="w-full h-full flex items-center justify-center cursor-pointer" @click="togglePlay" tabindex="0"
            :aria-button-role="isPlaying ? 'pause video' : 'play video'" role="button">
            <i v-if="isPlaying" class="icon-pause h-5 w-5 text-black block scale-[1.04]"></i>
            <i v-else class="icon-play-frag h-5 w-5 text-black block scale-[1.04]"></i>
        </button>
        <div
            class="play-tooltip text-3xs absolute left-0 top-1/2 p-2 bg-black text-white w-max -translate-x-full -translate-y-1/2 -left-3">
            {{ isPlaying ? 'Stop Video' : 'Play Video' }}
        </div>
        <div
            class="play-tooltip-arrow absolute left-0 top-1/2 w-0 h-0 border-y-[7px] border-r-0 border-l-8 border-transparent border-l-black -translate-x-full -translate-y-1/2 -left-1">
        </div>
    </div>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
    props:{
        isPlaying:{
            type: Boolean,
            required: true
        },
        togglePlay:{
            type: Function,
            required: true
        }
    },
})
</script>
<style scoped>

.play-btn .play-tooltip,
.play-btn .play-tooltip-arrow{
    display: none;
}
.play-btn:hover .play-tooltip,
.play-btn:hover .play-tooltip-arrow{
    display: block;
}
</style>